import { IncomingMessage } from 'http';
import { isArray } from 'lodash';
import { LoggerService } from '../services/LoggerService/LoggerService';

export const OFFICE_IPS = ['49.255.19.34', '54.253.72.214', '103.35.225.214'];

export const officeIPFilter = (request?: IncomingMessage, logger?: LoggerService) => {
  if (!request) return false;

  const ip = clientIP(request);

  logger?.info('IP filter', { ipfiltered: ip });

  return OFFICE_IPS.includes(ip ?? 'unknown-ip');
};

export const clientIP = (request: IncomingMessage) => {
  const ip =
    request.headers['x-real-ip'] ||
    request.headers['x-forwarded-for'] ||
    request.connection.remoteAddress;

  if (isArray(ip)) return ip[0] ?? null;
  else return ip ?? null;
};
